import React, { useState } from "react";
import { faqs } from "../../data/faqData";
import Button from "../Button/Button";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import './FAQSection.css';

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="faq-container">
      
      {/* Left Section */}
      <div className="faq-left">
        <div className="faq-left-1">
            <h1 className="faq-title">Your Questions are</h1>
            <h1 className="faq-title-highlight">Answered here.</h1>

            <p className="faq-description">
              Not sure what to expect? These answers might help you feel more
              confident as you begin.
            </p>
        </div>
        <div className="faq-left-2">
            <p className="faq-message">
              Didn’t find your answer? Send us a message — we’ll respond with care
              and clarity.
            </p>

            <div className="faq-btn-wrapper">
                <Button 
                  variant="primary" 
                  showArrow={true}
                  className="faq-contact-btn"
                  onClick={() => navigate('/contactus')}
                >
                  CONTACT US
                </Button>
            </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="faq-right">
        {faqs.map((item, index) => (
          <div
            key={index}
            className="faq-item"
            onClick={() => setOpen(open === index ? null : index)}
          >
            <div className="faq-question">
              <p>{item.q}</p>
              <span>
                {open === index ? (
                  <MdKeyboardArrowUp className="faq-icon" /> 
                ) : (
                  <MdKeyboardArrowDown className="faq-icon" />
                )}
              </span>
            </div>

            <div className={`faq-answer-container ${open === index ? 'open' : ''}`}>
               <p className="faq-answer">{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
